module.exports = __webpack_public_path__ + "img/Woman-10.ff69f7df.svg";